import {styled, Box, Typography} from "@mui/material";
import { Container as OriginalContainer } from "./MonthlyExpensesLayoutComponents";

export const OuterContainer = styled(OriginalContainer)(({theme}) => ({
    height: '100%',

    [theme.breakpoints.down('xl')]: {
        padding: theme.spacing(2),
    },
}));

export const Container = styled(Box)(({theme}) => ({
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('xl')]: {
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
}));

export const ItemContainer = styled(Box)(({theme}) => ({
    padding: theme.spacing(3),

    paddingRight: theme.spacing(5),
    paddingLeft: theme.spacing(5),
    borderRight: 'solid 2px',
    borderRightColor: theme.palette.grey[300],
    
    '&:last-of-type': {
        borderRight: 0,
    },

    [theme.breakpoints.only('xxl')]: {
        paddingRight: theme.spacing(10),
        paddingLeft: theme.spacing(10),
    },

    [theme.breakpoints.down('xl')]: {
        border: 0,
        padding: theme.spacing(2),
    },

    [theme.breakpoints.only('xs')]: {
        display: 'flex',
        alignItems: 'center',
        padding: 0,
    },
}));

export const Title = styled(Typography)(({theme}) => ({
    color: theme.palette.grey[600],
    fontWeight: 100,

    [theme.breakpoints.down('sm')]: {
        display: 'block',
        marginLeft: theme.spacing(1),
    },
}));

export const Amount = styled(Typography)(({theme}) => ({
    color: theme.palette.primary.main,
    fontWeight: 400,

    [theme.breakpoints.down('xl')]: {
        marginTop: theme.spacing(-1),
        fontSize: 50,
    },
    [theme.breakpoints.down('sm')]: {
        marginTop: 0,
        fontSize: 40,
    },
}));
